import { GET_SUBVENDOR_LIST, GET_SUBVENDOR_DETAILS, GET_ADDSUBVENDOR, GET_UPDATESUBVENDOR} from "resources/actionTypes";

export function getSubVendor(data) {
  return {
    type: GET_SUBVENDOR_LIST.GET_SUBVENDOR_LIST_REQUESTED,
    payload: data,
  };
}

export function postAddSubVendor(userAddSubVendor) {
  const data ={
    userAddSubVendor:userAddSubVendor,
  }
  return {
    type: GET_ADDSUBVENDOR.GET_ADDSUBVENDOR_REQUESTED,
    payload: data,
  };
}

export function patchUpdateSubVendor(userUpdateSubVendor) {
  const data ={
    userUpdateSubVendor:userUpdateSubVendor,
  }
  return {
    type: GET_UPDATESUBVENDOR.GET_UPDATESUBVENDOR_REQUESTED,
    payload: data,
  };
}

export function getDetailSubVendor(data) {
  return {
    type: GET_SUBVENDOR_DETAILS.GET_SUBVENDOR_DETAILS_REQUESTED,
    payload: data,
  };
}
